define(function(require) {
	const IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot:'/delegate/civics-api/api/cdr/applications/{0}/{1}/electronicplanreview/customer/token',
		url: function () {
			var url = null;
			if (this.instrumentType &&  this.instrumentID) {
				url = this.urlRoot.format(this.instrumentType, this.instrumentID);
			}
			return url;
		},
		parse: function (response) {
			return response;
		}
	});
});
